'use strict';

const urlUtil = {};

/**
 * Creates a new url string with an added or changed parameter
 * @param {string} paramName - the (new) parameter name
 * @param {string} paramValue - the new/changed parameter value
 * @param {string} href - [window.location.href] or equivalent
 * @param {string} hash - [window.location.hash] or equivalent
 * @returns {string} the new url
 */
urlUtil.getUrlWithNewParameter = function (paramName, paramValue, href = window.location.href, hash = window.location.hash) {
  if (paramName === null || paramValue === null) {
    return href;
  }

  let url = href.replace(hash, '');
  const pName = encodeURI(paramName);
  const pValue = encodeURI(paramValue);

  if (url.indexOf(pName + '=') >= 0) {
    const prefix = url.substring(0, url.indexOf(pName));
    let suffix = url.substring(url.indexOf(pName));
    suffix = suffix.substring(suffix.indexOf('=') + 1);
    suffix = suffix.indexOf('&') >= 0 ? suffix.substring(suffix.indexOf('&')) : '';
    url = prefix + pName + '=' + pValue + suffix;
  } else if (url.indexOf('?') < 0) {
    url += '?' + pName + '=' + pValue; // No parameters present
  } else {
    url += '&' + pName + '=' + pValue; // Parameters present
  }
  return url + hash;
};

/**
 * Gets a parameter from a link or from [window.location.href]
 * @param {string} paramName - the parameter name
 * @param {string} url - [window.location.href] or equivalent
 * @returns {string} the parameter value or [null]
 */
urlUtil.getParameterByName = function (paramName, url = window.location.href) {
  const name = paramName.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

/**
 * Adds or changes a parameter in the current URL.
 * @param {string} paramName - the parameter name
 * @param {string} paramValue - the parameter value
 * @param {boolean} replace - if [false] it will add a new entry to the browser's history
 */
urlUtil.changeCurrentUrlWithParam = function (paramName, paramValue, replace = true) {
  const newUrl = urlUtil.getUrlWithNewParameter(paramName, paramValue);

  if (replace) {
    window.history.replaceState({}, document.title, newUrl);
  } else {
    window.history.pushState({}, document.title, newUrl);
  }
};

/**
 * Increments a parameter in the current URL.
 * @param {string} paramName - the parameter name
 * @param {string} defaultValue - the value to be incremented if no such parameter is found
 * @param {boolean} replace - if [false] it will add a new entry to the browser's history
 */
urlUtil.incrementCurrentUrlParam = function (paramName, defaultValue = 0, replace = true) {
  const paramValue = urlUtil.getParameterByName(paramName);
  let paramNumber;

  if (paramValue) {
    paramNumber = parseInt(paramValue, 10);
  } else {
    paramNumber = defaultValue;
  }

  if (typeof paramNumber === 'number' && isFinite(paramNumber)) {
    paramNumber++;
    urlUtil.changeCurrentUrlWithParam(paramName, paramNumber, replace);
  }
};

module.exports = urlUtil;
